import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetCardComponent, AssetCardData } from '../../../../shared/components/asset-card/asset-card.component';
import { CarouselComponent } from '../../../../shared/components/primeng/carousel/carousel.component';

@Component({
  selector: 'app-challenge-assets-content',
  standalone: true,
  imports: [CommonModule, AssetCardComponent, CarouselComponent],
  templateUrl: './challenge-assets-content.component.html',
  styleUrl: './challenge-assets-content.component.scss'
})
export class ChallengeAssetsContentComponent {
  @Input() datasets: AssetCardData[] = [];
  @Input() models: AssetCardData[] = [];
  @Input() loading: boolean = false;
  /** When true (e.g. preview mode), asset cards do not navigate on click. */
  @Input() previewMode: boolean = false;
}


